import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import h from 'react-hyperscript';
import {Dialog} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import ShareReportLink from 'Components/ShareReportLink/ShareReportLink';
import './ShareLinkModal.scss';

const DialogContent = withStyles((theme) => ({
  root: {
    padding: 0,
    margin: 0,
  },
}))(MuiDialogContent);


export default function ShareLinkModal(props) {
  return (
    h(React.Fragment, [
      h(Dialog, {
        'onClose': props.handleClose,
        'key': 'share-link-modal',
        'aria-labelledby': 'customized-dialog-title',
        'open': props.open,
      }, [
        h(MuiDialogTitle, {
          'className': 'share-link-modal__title',
        }, [
          h('span', {
            className: 'share-link-modal__icon material-icons',
          }, 'link'),
          'Get shareable link',
          h(IconButton, {
            label: 'close',
            className: 'close-button',
            id: 'share-link-modal__close',
            onClick: props.handleClose,
          }, [
            h(CloseIcon),
          ]),
        ]),
        h(DialogContent, {
          dividers: false,
        }, [
          h(
              'div',
              {
                className: 'share-link-modal__container',
              },
              [
                h(ShareReportLink),
              ]
          ),
        ]),

      ]),
    ])

  );
}
